import useNameAttribute from "@hooks/attributes/useNameAttribute"
import useAttribute from "@hooks/useAttribute"
import _ from "lodash"

export default function useAttributes(
    salon: Model.Response<Admin.Resources.Salon>
): Admin.Models.Salon.Attrs {
    const name = useNameAttribute(salon)
    const maxScore = useMaxScoreAttribute(salon)

    return {
        name,
        maxScore
    }
}

function useMaxScoreAttribute(salon: Model.Response<Admin.Resources.Salon>) {
    return useAttribute(salon.data, salon => salon.juries.length * 10, 0)
}